/* istanbul ignore file */
export const roleAccess = {
    USER: 'User',
    ADMINISTRATOR: 'Administrator',
    COMPANY: 'Company',
    ANNOTATOR: 'Annotator',
    SUPERVISOR: 'Supervisor'
}